import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PageHeaderAlertTypes } from '../../../../utils/page-header-alert-types';
import { BannerVariant } from './types';
import { Routes } from '../../../../routes';

type State = {
  bannerAlert: string;
  icon: string;
  message: string;
  CTAText: string;
  bannerAlertType: string;
  CTAType: string;
  CTAUrl: string;
  target: string;
  bannerMessageOne: string;
  bannerMessageTwo: string;
  paymentActionType: string;
  ctaHandlerType: string;
  ctaBtnText: string;
};

export type SetPageHeaderBannerAlertPayload = {
  bannerType: string;
  paymentActionUrl?: string;
  message?: string;
  ctaText?: string;
  bannerMessageOne?: string;
  bannerMessageTwo?: string;
  paymentActionType?: string;
  ctaHandlerType?: 'redirect' | 'contact-owner';
  ctaBtnText?: string;
  ctaUrl?: string;
};

const initialState: State = {
  bannerAlert: '',
  icon: '',
  message: '',
  CTAText: '',
  bannerAlertType: '',
  CTAType: '',
  CTAUrl: '',
  target: '',
  bannerMessageOne: '',
  bannerMessageTwo: '',
  paymentActionType: '',
  ctaHandlerType: '',
  ctaBtnText: '',
};

const pageHeaderSlice = createSlice({
  name: 'pageHeaderBannerAlert',
  initialState,
  reducers: {
    setPageHeaderBannerAlert: (
      state,
      action: PayloadAction<SetPageHeaderBannerAlertPayload>,
    ) => {
      switch (action.payload.bannerType) {
        case PageHeaderAlertTypes.PAYMENT_PENDING: {
          state.bannerAlert = PageHeaderAlertTypes.PAYMENT_PENDING;
          state.icon = 'svg';
          state.message =
            action.payload.message || action.payload.bannerMessageOne;
          state.bannerMessageTwo = action.payload.bannerMessageTwo;
          state.paymentActionType = action.payload.paymentActionType;
          state.CTAText = action.payload.ctaText || 'Take action now';
          state.bannerAlertType = BannerVariant.Danger;
          state.CTAType = 'redirect';
          state.CTAUrl = action.payload.paymentActionUrl;
          state.target = '_blank';
          break;
        }
        case PageHeaderAlertTypes.TRIAL_EXPIRED: {
          state.bannerAlert = PageHeaderAlertTypes.TRIAL_EXPIRED;
          state.icon = 'svg';
          state.message = action.payload.message;
          state.CTAText = action.payload.ctaText;
          state.bannerAlertType = BannerVariant.Danger;
          state.CTAType = 'redirect';
          state.CTAUrl = Routes.Setting_Billing_Upgrade_Email_Outreach_Plan;
          break;
        }
        case PageHeaderAlertTypes.DOMAIN_RENEWAL: {
          state.bannerAlert = PageHeaderAlertTypes.DOMAIN_RENEWAL;
          state.icon = 'svgz';
          state.message = action.payload.message;
          state.ctaHandlerType = action.payload.ctaHandlerType || 'redirect';
          state.bannerAlertType = BannerVariant.Danger;
          state.ctaBtnText = action.payload.ctaBtnText || '';
          if (action.payload.ctaHandlerType === 'contact-owner') {
            state.CTAText = '';
            state.CTAUrl = '';
            state.target = '';
          } else {
            state.CTAText = action.payload.ctaText || 'Renew Now';
            state.CTAUrl =
              action.payload.ctaUrl ||
              Routes.Setting_Billing_Sending_Infrastructure;
            state.target = '';
          }
          break;
        }
        case PageHeaderAlertTypes.SUBSCRIPTION_RENEWAL: {
          state.bannerAlert = PageHeaderAlertTypes.SUBSCRIPTION_RENEWAL;
          state.icon = 'svgz';
          state.message = action.payload.message || '';
          state.ctaHandlerType = action.payload.ctaHandlerType || 'redirect';
          state.bannerAlertType = BannerVariant.Danger;
          state.ctaBtnText = action.payload.ctaBtnText || '';
          if (action.payload.ctaHandlerType === 'contact-owner') {
            state.CTAText = '';
            state.CTAUrl = '';
            state.target = '';
          } else {
            state.CTAText = action.payload.ctaText || '';
            state.CTAUrl = action.payload.ctaUrl || Routes.Email_Infra_Pay;
            state.target = '';
          }
          break;
        }
        case PageHeaderAlertTypes.NONE: {
          state.CTAText = initialState.CTAText;
          state.CTAType = initialState.CTAType;
          state.CTAUrl = initialState.CTAUrl;
          state.bannerAlert = initialState.bannerAlert;
          state.bannerAlertType = initialState.bannerAlertType;
          state.icon = initialState.icon;
          state.message = initialState.message;
          state.target = initialState.target;
          state.ctaHandlerType = initialState.ctaHandlerType;
          state.ctaBtnText = initialState.ctaBtnText;
          break;
        }

        default:
          break;
      }
    },
  },
});

export const { setPageHeaderBannerAlert } = pageHeaderSlice.actions;
export default pageHeaderSlice.reducer;
